import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import { useDispatch } from 'react-redux';
import { handleCreateFile } from '../actions/files';
import { CREATE_FILE_REGEX } from '../../../utils/fileUtils';

import { Button, ButtonTypes } from '../../../common/Button';

function NewFileForm() {
  const fileNameInput = useRef(null);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  function onSubmit(formProps) {
    return dispatch(handleCreateFile(formProps));
  }

  function validate(formProps) {
    const errors = {};

    if (!formProps.name) {
      errors.name = t('NewFileModal.EnterName');
    } else if (!formProps.name.match(CREATE_FILE_REGEX)) {
      errors.name = t('NewFileModal.InvalidType');
    }

    return errors;
  }

  useEffect(() => {
    fileNameInput.current.focus();
  });

  return (
    <Form fields={['name']} validate={validate} onSubmit={onSubmit}>
      {({ handleSubmit, errors, touched, invalid, submitting }) => (
        <form className="new-file-form" onSubmit={handleSubmit}>
          <div className="new-file-form__input-wrapper">
            <Field name="name">
              {(field) => (
                <React.Fragment>
                  <label className="new-file-form__name-label" htmlFor="name">
                    Name:
                  </label>
                  <input
                    className="new-file-form__name-input"
                    id="name"
                    type="text"
                    placeholder={t('NewFileForm.Placeholder')}
                    maxLength="128"
                    {...field.input}
                    ref={fileNameInput}
                  />
                </React.Fragment>
              )}
            </Field>
            <Field name="submitButton">
              {() => (
                <Button type={ButtonTypes.SUBMIT} disabled={submitting}>
                  {t('NewFileForm.AddFileSubmit')}
                </Button>
              )}
            </Field>
          </div>
          {touched.submitButton && errors.name && (
            <span className="form-error" aria-live="polite">
              {errors.name}
            </span>
          )}
        </form>
      )}
    </Form>
  );
}

export default NewFileForm;
